/* mc-gallery.js — product gallery: lightbox, swipe, and the card slot.

   The gallery itself switches with CSS only (hidden radios, :checked ~
   sibling rules in bh.css) and keeps working with this file blocked.
   Everything here is added on top:

     · the whole frame becomes a button that opens a lightbox
     · swipe, arrows, dots and Escape inside it
     · the fourth slot, which is the dedication card RENDERED from what
       the customer typed rather than a photograph of someone else's

   That last one is the reason this file exists. Handover §2: the card
   has to be seen before it is paid for, and a stock image cannot do
   that. It listens for mc:dedication, which mc-dedication.js emits on
   every keystroke. */
(function () {
  'use strict';

  var gallery = document.querySelector('.bh-gallery');
  var lb      = document.querySelector('[data-mc-lightbox]');
  if (!gallery) return;

  /* ---------- the card slot ------------------------------- */

  var cardPanel = gallery.querySelector('[data-mc-gal-card]');
  var cardThumb = gallery.querySelector('[data-mc-gal-thumb]');
  var cardRadio = gallery.querySelector('[data-mc-gal-radio]');
  var outTitle  = gallery.querySelector('[data-mc-gal-title]');
  var outText   = gallery.querySelector('[data-mc-gal-text]');
  var outSign   = gallery.querySelector('[data-mc-gal-sign]');

  document.addEventListener('mc:dedication', function (ev) {
    if (!cardPanel || !ev.detail) return;
    var d = ev.detail;

    /* No card ordered, or nothing written yet: the slot disappears
       rather than sitting there empty, which reads as a broken image.
       If it was the selected slot, hand the selection back to the first
       photograph — otherwise the gallery goes blank. */
    var show = d.card && (d.text || '').trim() !== '';
    cardPanel.hidden = !show;
    if (cardThumb) cardThumb.hidden = !show;

    if (!show) {
      if (cardRadio && cardRadio.checked) {
        var first = gallery.querySelector('.bh-gal');
        if (first) first.checked = true;
      }
      return;
    }

    /* The property carries "Title — text"; split it back for display so
       the card reads the way it will be printed. textContent throughout:
       this is a stranger's typing being put back on the page. */
    var parts = String(d.text).split(' — ');
    var title = parts.length > 1 ? parts.shift() : '';
    var body  = parts.join(' — ');

    if (outTitle) { outTitle.textContent = title; outTitle.hidden = !title; }
    if (outText)  { outText.textContent  = body; }
    if (outSign)  { outSign.textContent  = d.sign || ''; outSign.hidden = !d.sign; }
  });

  /* ---------- swipe the gallery itself --------------------- */
  /* Reported by the shop: "swipe slika ne radi". It never did — swipe
     was only ever implemented inside the lightbox, so dragging across
     the photograph on the page did nothing and the only way to change
     picture was the thumbnail strip.

     The gallery switches with hidden radios and :checked sibling rules,
     so this does not move anything itself: it checks the next radio and
     lets the CSS do what it already does. */
  var swiped = false;

  (function galleySwipe() {
    var main = document.querySelector('.bh-gallery__main');
    if (!main) return;

    function radios() {
      /* Photograph slots only. The card slot is type, not a picture, and
         swiping onto a blank card mid-gallery reads as a broken image. */
      return [].slice.call(document.querySelectorAll('.bh-gal:not(.mc-gal__radio)'));
    }

    var x0 = null, y0 = null;
    main.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });

    main.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      x0 = null; y0 = null;
      /* Horizontal intent only, and a real distance: the page scrolls
         vertically through this element, and stealing that makes the
         whole gallery feel stuck. */
      if (Math.abs(dx) < 45 || Math.abs(dx) <= Math.abs(dy)) return;

      /* A touch that ends as a swipe still fires click, and click on
         this frame opens the lightbox — so without this every swipe
         would also open it. Cleared on the next tick, after the click
         that follows this touch has been and gone. */
      swiped = true;
      setTimeout(function () { swiped = false; }, 0);

      var r = radios();
      var i = r.findIndex(function (n) { return n.checked; });
      if (i < 0) i = 0;
      var next = i + (dx < 0 ? 1 : -1);
      if (next < 0) next = r.length - 1;
      if (next >= r.length) next = 0;
      if (r[next]) r[next].checked = true;
    }, { passive: true });
  })();

  /* ---------- lightbox ------------------------------------ */

  if (!lb) return;

  var frame = lb.querySelector('[data-mc-lb-frame]');
  var dots  = lb.querySelector('[data-mc-lb-dots]');
  var prevB = lb.querySelector('[data-mc-lb-prev]');
  var nextB = lb.querySelector('[data-mc-lb-next]');
  var main  = gallery.querySelector('.bh-gallery__main');
  if (!frame || !main) return;

  function shots() {
    return Array.prototype.slice.call(gallery.querySelectorAll('.bh-gal__img'))
      .filter(function (n) { return n.tagName === 'IMG'; });
  }

  /* Full-resolution sources, positional, emitted as JSON by the section.
     They are not data- attributes on the images because image_tag takes
     its attributes as Liquid arguments and a Liquid argument name cannot
     contain a hyphen. */
  var FULL = (function () {
    var el = gallery.querySelector('[data-mc-gal-full]');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  })();

  var idx = 0;
  var lastFocus = null;

  function draw() {
    var list = shots();
    if (!list.length) return;
    if (idx < 0) idx = list.length - 1;
    if (idx >= list.length) idx = 0;

    var src = list[idx];
    frame.innerHTML = '';
    var img = document.createElement('img');
    /* Falling back to what the page already loaded keeps the lightbox
       working if the JSON block is ever missing, rather than opening an
       empty frame — a smaller picture beats no picture. */
    img.src = FULL[idx] || src.currentSrc || src.src;
    img.alt = src.alt || '';
    img.className = 'mc-lb__img';
    /* Each picture starts unzoomed, and the cap is its own — the next
       photograph may be 2048px where this one was 1000. */
    img.addEventListener('load', function () { resetZoom(); });
    frame.appendChild(img);
    zs = 1; ztx = 0; zty = 0;
    if (img.complete) resetZoom();

    if (dots) {
      dots.innerHTML = '';
      list.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mc-lb__dot' + (i === idx ? ' is-on' : '');
        b.setAttribute('aria-label', String(i + 1));
        b.addEventListener('click', function () { idx = i; draw(); });
        dots.appendChild(b);
      });
    }

    var many = list.length > 1;
    if (prevB) prevB.hidden = !many;
    if (nextB) nextB.hidden = !many;
    if (dots)  dots.hidden  = !many;
  }

  function open(at) {
    var list = shots();
    if (!list.length) return;
    idx = at || 0;
    lastFocus = document.activeElement;
    /* Moved to <body> so no ancestor's transform, filter or overflow can
       trap a position:fixed overlay — the classic way a lightbox ends up
       clipped inside a card. */
    if (lb.parentNode !== document.body) document.body.appendChild(lb);
    lb.hidden = false;
    document.body.style.overflow = 'hidden';
    draw();
    var x = lb.querySelector('[data-mc-lb-close]');
    if (x && x.focus) x.focus();
  }

  function close() {
    zs = 1; ztx = 0; zty = 0;
    lb.removeAttribute('data-zoomed');
    lb.hidden = true;
    document.body.style.overflow = '';
    frame.innerHTML = '';   /* stop a large image decoding behind a closed overlay */
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* The whole frame opens it. A magnifier icon in the corner would be a
     small target for a thumb already aiming at the picture. Added here
     rather than in the markup: without this file there is nothing to
     open, and a button that does nothing is worse than no button. */
  main.setAttribute('role', 'button');
  main.setAttribute('tabindex', '0');
  main.setAttribute('aria-label', main.getAttribute('aria-label') || 'Uvećaj sliku');
  main.style.cursor = 'zoom-in';

  main.addEventListener('click', function (e) {
    /* The click that trails a swipe is not a request to enlarge. */
    if (swiped) return;
    /* Not on the card slot — it is type, and enlarging it shows nothing
       the customer cannot already read. */
    if (e.target.closest && e.target.closest('[data-mc-gal-card]')) return;
    var list = shots();
    var vis = list.findIndex(function (n) { return n.offsetParent !== null; });
    open(vis < 0 ? 0 : vis);
  });
  main.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); main.click(); }
  });

  lb.addEventListener('click', function (e) {
    if (e.target.closest('[data-mc-lb-close]')) close();
  });
  if (prevB) prevB.addEventListener('click', function () { idx--; draw(); });
  if (nextB) nextB.addEventListener('click', function () { idx++; draw(); });

  document.addEventListener('keydown', function (e) {
    if (lb.hidden) return;
    if (e.key === 'Escape')     close();
    if (e.key === 'ArrowLeft')  { idx--; draw(); }
    if (e.key === 'ArrowRight') { idx++; draw(); }
  });

  /* ---------- real magnification --------------------------

     The overlay used to stop at fit-to-screen, which on a 1000px master
     and a 1080p display is 952px against the 799px the page already
     showed — a 19% enlargement behind a click, for jewellery, where the
     whole question is what the stone and the clasp look like.

     Scale is capped at the master's own pixels. On a 2048px photograph
     that is a real 2x; on a 1000px one the zoom stops early rather than
     enlarging into mush, because a blurry close-up of a clasp answers
     the customer's question wrongly rather than not at all.

     The image is painted by object-fit:contain, so the element box is
     not the picture — the letterbox is computed here and every clamp is
     against the PAINTED rect. */

  var zs = 1, ztx = 0, zty = 0, zmax = 1, pw = 0, ph = 0;

  function zoomImg() { return frame.querySelector('.mc-lb__img'); }

  function measure() {
    var img = zoomImg();
    if (!img || !img.naturalWidth) { zmax = 1; pw = ph = 0; return; }
    var fr = frame.getBoundingClientRect();
    /* A frame with no size yet — first paint, a backgrounded tab — makes
       fit 0, pw 0, and naturalWidth/0 Infinity, which Math.min turns into
       the hard cap of 4. The native-pixel limit would vanish exactly
       where it matters and a 1000px master would enlarge 4x into mush.
       Measure again later instead; every entry point re-measures when pw
       is still 0. */
    if (!fr.width || !fr.height) { zmax = 1; pw = ph = 0; return; }
    var fit = Math.min(fr.width / img.naturalWidth, fr.height / img.naturalHeight);
    pw = img.naturalWidth * fit;
    ph = img.naturalHeight * fit;
    /* Native pixels, never past them, and never a pointless 1.05x. */
    zmax = Math.max(1, Math.min(4, img.naturalWidth / pw));
    if (zmax < 1.15) zmax = 1;
  }

  function clamp() {
    var fr = frame.getBoundingClientRect();
    var mx = Math.max(0, (pw * zs - fr.width) / 2);
    var my = Math.max(0, (ph * zs - fr.height) / 2);
    ztx = Math.max(-mx, Math.min(mx, ztx));
    zty = Math.max(-my, Math.min(my, zty));
  }

  function paint() {
    var img = zoomImg();
    if (!img) return;
    clamp();
    img.style.transform = 'translate(' + ztx + 'px,' + zty + 'px) scale(' + zs + ')';
    img.style.cursor = zmax === 1 ? 'default' : (zs > 1 ? 'grab' : 'zoom-in');
    lb.setAttribute('data-zoomed', zs > 1 ? 'true' : 'false');
  }

  function resetZoom() { zs = 1; ztx = 0; zty = 0; measure(); paint(); }

  /* Zoom about a point, so the detail under the finger stays under it. */
  function zoomTo(next, cx, cy) {
    if (!pw) measure();          /* the frame may not have had a size yet */
    next = Math.max(1, Math.min(zmax, next));
    var fr = frame.getBoundingClientRect();
    var ox = cx - (fr.left + fr.width / 2);
    var oy = cy - (fr.top + fr.height / 2);
    var k = next / zs;
    ztx = ox - (ox - ztx) * k;
    zty = oy - (oy - zty) * k;
    zs = next;
    if (zs === 1) { ztx = 0; zty = 0; }
    paint();
  }

  frame.addEventListener('dblclick', function (e) {
    if (!pw) measure();
    if (zmax === 1) return;
    zoomTo(zs > 1 ? 1 : Math.min(2.5, zmax), e.clientX, e.clientY);
  });

  frame.addEventListener('wheel', function (e) {
    if (!pw) measure();
    if (zmax === 1) return;
    e.preventDefault();
    zoomTo(zs * (e.deltaY < 0 ? 1.16 : 1 / 1.16), e.clientX, e.clientY);
  }, { passive: false });

  /* Mouse drag to pan, only while there is something to pan to. */
  var drag = null;
  frame.addEventListener('mousedown', function (e) {
    if (zs <= 1) return;
    e.preventDefault();
    drag = { x: e.clientX, y: e.clientY, tx: ztx, ty: zty };
    var img = zoomImg(); if (img) img.style.cursor = 'grabbing';
  });
  document.addEventListener('mousemove', function (e) {
    if (!drag) return;
    ztx = drag.tx + (e.clientX - drag.x);
    zty = drag.ty + (e.clientY - drag.y);
    paint();
  });
  document.addEventListener('mouseup', function () { drag = null; paint(); });

  /* ---------- touch: pinch, pan, swipe ---------------------

     One finger means different things at different scales, and that is
     the whole trick: zoomed in it pans, zoomed out it navigates. Two
     fingers always pinch. A downward swipe closes — the gesture every
     photo viewer on a phone already uses — while horizontal keeps its
     old job of changing picture. Upward is left alone: it is how
     somebody tries to scroll, and stealing it makes the overlay feel
     stuck. */
  var t0 = null, pinch0 = null;

  function dist(t) {
    var dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  lb.addEventListener('touchstart', function (e) {
    if (e.touches.length === 2) {
      pinch0 = { d: dist(e.touches), s: zs,
                 cx: (e.touches[0].clientX + e.touches[1].clientX) / 2,
                 cy: (e.touches[0].clientY + e.touches[1].clientY) / 2 };
      t0 = null;
    } else if (e.touches.length === 1) {
      t0 = { x: e.touches[0].clientX, y: e.touches[0].clientY, tx: ztx, ty: zty, t: 0 };
    }
  }, { passive: true });

  lb.addEventListener('touchmove', function (e) {
    if (pinch0 && e.touches.length === 2) {
      e.preventDefault();
      zoomTo(pinch0.s * (dist(e.touches) / pinch0.d), pinch0.cx, pinch0.cy);
      return;
    }
    if (t0 && e.touches.length === 1 && zs > 1) {
      e.preventDefault();
      ztx = t0.tx + (e.touches[0].clientX - t0.x);
      zty = t0.ty + (e.touches[0].clientY - t0.y);
      paint();
    }
  }, { passive: false });

  lb.addEventListener('touchend', function (e) {
    if (pinch0) { pinch0 = null; if (zs <= 1.02) resetZoom(); return; }
    if (!t0) return;
    var dx = e.changedTouches[0].clientX - t0.x;
    var dy = e.changedTouches[0].clientY - t0.y;
    t0 = null;
    if (zs > 1) return;                                  /* that was a pan */
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
      idx += dx < 0 ? 1 : -1;
      draw();
    } else if (dy > 90 && Math.abs(dy) > Math.abs(dx)) {
      close();
    }
  }, { passive: true });

  /* Double-tap, which iOS does not send as dblclick on a non-link. */
  var lastTap = 0;
  lb.addEventListener('touchend', function (e) {
    if (!pw) measure();
    if (zmax === 1 || e.changedTouches.length !== 1) return;
    var now = e.timeStamp || 0;
    if (now - lastTap < 300) {
      zoomTo(zs > 1 ? 1 : Math.min(2.5, zmax),
             e.changedTouches[0].clientX, e.changedTouches[0].clientY);
      lastTap = 0;
    } else {
      lastTap = now;
    }
  }, { passive: true });

  window.addEventListener('resize', function () { if (!lb.hidden) resetZoom(); }, { passive: true });
})();
